import { ResolveUnclearAssignmentRequestSchema, ResolveUnclearAssignmentResponseSchema } from './resolve-unclear-assignment.schema';
/**
 * Resolve Unclear Assignment Endpoint Contract
 * Resolves an unclear assignment by reassigning it to another user
 */ export const resolveUnclearAssignmentContract = {
    method: 'POST',
    path: '/api/v2/process-step-assignment/:id/unclear-reassignment',
    description: 'Resolve an unclear assignment by reassigning to another user',
    requestSchema: ResolveUnclearAssignmentRequestSchema,
    responseSchema: ResolveUnclearAssignmentResponseSchema,
    statusCodes: {
        success: 204,
        errors: {
            400: 'Invalid request body or assignment not found',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user cannot resolve this assignment'
        }
    }
};

//# sourceMappingURL=resolve-unclear-assignment.contract.js.map